if (!customElements.get('swym-wishlist-page')) {
    class SwymWishlistPage extends HTMLElement {
        constructor() {
            super();
            this._initializeSwymComponent();
        }

        _init(swat) {
            this._initializeSelectors(swat);
            this.isShareWishlistPage 
                ? this._renderShareWishlist(swat) 
                : this._renderWishlist();
            this._attachEventListeners();
        }

        /* General functions */

        _initializeSwymComponent() {
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors(swat) {
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.accountButtonText = this.accountButton.querySelector('.swymcs-user-text.swym-value');
            this.accountPopupTitleText = this.accountPopup.querySelector('#swymcs-account-popup-title');
            this.accountInfo = this.querySelector('#swymcs-account-info-text');
            this.accountInfoGuest = this.querySelector('#swymcs-account-info-guest');
            this.swymcsWishlistTab = this.querySelector('#swymcs-wishlist-tab');


            this.shareListAccountPopup = this.querySelector('#swymcs-share-list-login-status-popup');
            this.shareListAccountPopupTitleText = this.querySelector('#swymcs-share-list-account-popup-title');
            this.shareListAccountPopupContentText1 = this.querySelector('#swymcs-share-list-account-info-1');
            this.shareListAccountPopupContentText2 = this.querySelector('#swymcs-share-list-account-info-2');
            this.shareListAccountPopupCloseButton = this.querySelector('#swymcs-close-share-list-account-popup');
            this.shareListAccountPopupCancelButton = this.querySelector('#swymcs-cancel-share-list-account-popup');
            this.shareListAccountPopupActionButton = this.querySelector('#swymcs-share-list-account-login-action-button');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container');
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.EmptyContainer = this.querySelector('#swymcs-empty-grid');
            this.wishlistHeader = this.querySelector('.swymcs-options-container');

            /* Lists header selectors */
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

            /* Share List popup selectors */
            this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
            this.shareLinkField = this.querySelector('#swymcs-share-link-field');
            this.shareNameField = this.querySelector('#swymcs-share-name-field');
            this.shareEmailField = this.querySelector('#swymcs-share-email-field');
            this.shareMessageField = this.querySelector('#swymcs-share-message-field');
            this.shareListError = this.querySelector('#swymcs-share-email-field-error');
            this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
            this.emailShareCancelButton = this.querySelector('#swymcs-cancel-share-list');
            this.shareListPopupTitle = this.shareListPopup.querySelector('.swymcs-confirm-share-title');
            this.shareListPopupSubtitle = this.shareListPopup.querySelector('.swymcs-confirm-share-subtitle');
            this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
            this.copyLinkButtonText = this.copyLinkButton.querySelector('.swymcs-share-button-text');
            this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
            this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
            this.shareListPopupSenderNameLabel = this.shareListPopup.querySelector('[for="swymcs-share-name-field"]');
            this.shareListPopupSenderEmailLabel = this.shareListPopup.querySelector('[for="swymcs-share-email-field"]');
            this.shareListPopupSenderNotesLabel = this.shareListPopup.querySelector('[for="swymcs-share-message-field"]');

            /* Delete List popup selectors */
            this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
            this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
            this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list');
            this.deleteListPopupTitleText = this.deleteListPopup.querySelector('.swymcs-confirm-delete-title');
            this.deleteListPopupCancelBtn = this.querySelector('#swymcs-cancel-delete-list');
            this.deleteListConfirm = this.querySelector('.swymcs-confirm-delete-text .swymcs-popup-text.swymcs-popup-content');

            /* Rename List popup selectors */
            this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
            this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
            this.renameListError = this.querySelector('#swymcs-rename-list-error');
            this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
            this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list');

            /* Duplicate List popup selectors */
            this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
            this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
            this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
            this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
            this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list');

          this.emptyListTitle = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-title');
          this.emptyListDescription = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-description');
          this.emptyListButton = this.emptyListContainer.querySelector('#swym-custom-continue-shopping');

          if(!window.isCustomer){
              this.guestMessageButton = this.querySelector('#swymcs-guest-user-btn');
          }
        }     

        _attachEventListeners() {

            this.body.addEventListener('click', evt => this._overlayEvent(evt));
            this.addEventListener('swym:product-grid-loaded', this._updateLocaleStrings.bind(this));
            /* Adding events to page header elements */

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            this.shareListAccountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.shareListAccountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));
            this.shareListAccountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));  

            /* Additional Options Events */
            //this.additionalOptionsBtn.addEventListener('click', evt => this._renderDeleteList());
            
            this.additionalOptionsBtn.addEventListener('click', evt => this._renderDeleteListPopup());
            //this.additionalOptionsContainer.addEventListener('click', this._renderDeleteListPopup());
            
            //this.additionalOptionsContainer.addEventListener('click', this._renderDeleteList.bind(this));
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));

            /* Share List Events */
            this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
            this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
            this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
            this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
            this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

            /* Delete List Events */
            this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._selectProductSize);
        }

        _updateLocaleStrings(){
            const swat = this.swat;
            const loggedInAccountPopupText = swat.retailerSettings.Strings.SaveListPopupLoggedInText.replace(/{{{?email}?}}/g, window.customerEmail);
            const shareListNotesLabel = swat.retailerSettings.Strings.ShareWishlistPopupNoteDefault.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);
            this.ShareWishlistEmailSuccess = swat.retailerSettings.Strings.ShareWishlistEmailSuccess.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);
  
            /* MENU CONTAINER BUTTONS */
            //this.swymcsWishlistTab.textContent = swat.retailerSettings.Strings.WishlistTabCTA;
            if (!window.isCustomer) {
                this.accountButtonText.textContent = swat.retailerSettings.Strings.GuestShopperTitle;
            }

            this.accountPopupTitleText.textContent = swat.retailerSettings.Strings.SaveListPopupSummaryHeading;
            /*if (this.accountInfo)
                this.accountInfo.textContent = loggedInAccountPopupText;
            else
                this.accountInfoGuest.textContent = swat.retailerSettings.Strings.SaveListPopupSummaryText;*/

            /* NOT LOGGED IN CUSTOMER - ACCOUNT POPUP CONTAINER */
            this.accountPopupActionButton.textContent = window.isCustomer ? swat.retailerSettings.Strings.SaveListPopupLoggedInCTASave : swat.retailerSettings.Strings.SaveListPopupSummaryCTALogin;
            this.accountPopupCancelButton.textContent = swat.retailerSettings.Strings.SaveListPopupLoggedInCTACancel;
  
            /* DELETE LIST POPUP CONTAINER */
            this.deleteListPopupTitleText.textContent = swat.retailerSettings.Strings.ClearWishlistPopupHeading;
            //this.deleteListConfirm.textContent = swat.retailerSettings.Strings.DeleteWishlistPopupConfirmMessage;
            this.confirmDeleteListButton.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTAClear;
            this.deleteListPopupCancelBtn.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTACancel;
  
            /* NOT LOGGED IN CUSTOMER - SHARE LIST POPUP CONTAINER */
            this.shareListAccountPopupTitleText.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupHeading;
            this.shareListAccountPopupActionButton.textContent = swat.retailerSettings.Strings.SharedWishlistLoginCTA;
            this.shareListAccountPopupContentText1.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupText;
            this.shareListAccountPopupContentText2.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupMessage;
  
            /* SHARE LIST POPUP CONTAINER */
            this.shareListPopupTitle.textContent = swat.retailerSettings.Strings.ShareWishlistPopupHeading;
            this.shareListPopupSubtitle.textContent = swat.retailerSettings.Strings.ShareWishlistAlternateShareLabel;
            this.copyLinkButtonText.textContent = swat.retailerSettings.Strings.ShareWishlistCopyLinkText;
            this.shareListPopupSenderNameLabel.textContent = swat.retailerSettings.Strings.ShareWishlistSenderName;
            this.shareNameField.placeholder = swat.retailerSettings.Strings.ShareWishlistNamePlaceholder;
            this.shareListPopupSenderEmailLabel.textContent = swat.retailerSettings.Strings.ShareWishlistRecipientsEmail;
            this.shareEmailField.placeholder = swat.retailerSettings.Strings.ShareWishlistEmailPlaceholder;
            this.shareListPopupSenderNotesLabel.textContent = swat.retailerSettings.Strings.ShareWishlistMessage;
            this.shareMessageField.placeholder = swat.retailerSettings.Strings.ShareWishlistNotePlaceholder;
            this.shareMessageField.value = shareListNotesLabel;
            this.emailShareButton.textContent = swat.retailerSettings.Strings.ShareWishlistEmailCTA;
            this.emailShareCancelButton.textContent = swat.retailerSettings.Strings.DuplicateWishlistPopupCTACancel;
  
            /* EMPTY LIST CONTAINER */
            this.emptyListTitle.textContent = swat.retailerSettings.Strings.EmptyWishlistsHeading;
            this.emptyListDescription.textContent = swat.retailerSettings.Strings.EmptyWishlistsText;
            this.emptyListButton.textContent = swat.retailerSettings.Strings.EmptyWishlistsCTA;
        }

        async _renderWishlist() {
            this.lists = await this._getLists();
            this._renderSingleWishlist();
        }

        async _renderSingleWishlist() {
            if(this.lists[0])
            {
                window.currentActiveListId = this.lists[0].lid;
                const wishlistProducts = await this._getProductsFromList(window.currentActiveListId);
                const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
                this._renderProductsGrid(shopifyProductsData,'WL');
            }
            else
            {    
                const shopifyProductsData=[];
                this._renderProductsGrid(shopifyProductsData,'WL');
            }
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSingleListHeader(lid) {
            this._showContainer(this.additionalOptionsBtn);
        }

        async _renderShareWishlist() {
            const params = new URL(document.location).searchParams;
            const paramObj = Object.fromEntries(params.entries());
            const lid = params.get("lid");
            this._hideContainer(this.wishlistHeader);
            this._hideContainer(this.swymcsWishlistTab);
            if (!lid) {
                this._renderProductsGrid([],'WL');
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            this._renderProductsGrid(shopifyProductsData,'WL');
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderEmptyState() {
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }

        async _renderSharedListHeader(lid) {
            const activeList = await this._getListDetails(lid);
            this._renderActiveList(activeList.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        _renderListHeader(lid) {
            const lists = this.lists;
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if (listContents.length) {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                } else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list) {
            const listContent = list?.listcontents || [];
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if (listContent.length) {
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            } else {
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts,gridtype){
            let productMarkup = ``;
            if (!shopifyProducts.length) {
                this._showContainer(this.emptyListContainer);
                this._hideContainer(this.wishlistContainer);
            }
            else{
                this._showContainer(this.additionalOptionsBtn);
                shopifyProducts.forEach(async(pdp, index) => {
                    if (!pdp) return;
                    const product = pdp.productData;
                    const variants = pdp.productData.variants;
                    const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                    const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                    const selectedVariantPrice = parseFloat(selectedVariant.price / 100.00).toFixed(2);
                    let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${_swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded}` : `${_swat.retailerSettings.Strings.AddToCartCTACanAdd}`) : `${_swat.retailerSettings.Strings.AddToCartCTAUnavailable}`;
                    const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                    const lid = pdp.lid;
                    let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                    let isButtonDisabled = isSoldOut ? 'disabled' : '';
                    const imageSrc = selectedVariant ?.featured_image ?.src || product ?.featured_image || pdp.iu;
                    const productUrl = product.url + '?variant=' + selectedVariant.id;
                    let variantSelector=``;
                    variantSelector+=`
                        <select data-purpose="select" id="mySelect" class="${!selectedVariant.available ? 'swym-strikethrough' :''}">
                    `
                    variants.forEach(variant =>{
                        variantSelector+=`
                            <option value="${variant.id}" ${variant.id === selectedVariant.id ? 'selected' : ''} data-available=${variant.available} data-incart=${_swat.platform.isInDeviceCart(variant.id)}>${variant.title}</option>
                        `
                    })
                    variantSelector+=`
                        </select>
                    `
                    let backInStockButton = `
                        <div class="swymcs-atc-container">
                            <button data-purpose="subscribe" data-epi="${pdp.epi}" data-empi="${pdp.empi}" data-du="https://${window.shopDomain}/${product.url}" data-iu="${imageSrc}" data-pr="${selectedVariantPrice}" class=" ${selectedVariant.available ? 'swym-hide-container' :''} swymcs-bis-button btn btn--primary swymcs-button swymcs-primary-button button button--primary">${_swat.retailerSettings.Strings.WatchlistAddCTA}</div>
                        </div>
                    `;
                    productMarkup+= `
                        <div class="product swymcs-product" data-product-handle="${product.handle}">
                            <div class="nosto-product-info swymcs-product-card" data-product-handle="${product.handle}">
                            <div class="top-container">
                                <a class="nosto-product-images" href="${productUrl}">
                                <img src="${imageSrc}" alt="${product.title}" class="nosto-product-image">
                                
                                </a>


                                <div class="badges"></div>
                                <p class="hide replace-badges"></p>
                            
                                <div class="wishlist-new-pdp">
                                    <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="${this.settings.swym_delete_list_text} ${product.title}">
                                        <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                                    </button>
                                </div>
                                
                            </div>
                            <div class="bottom-container">
                                <a class="pdp-name-bottom-container" href="${productUrl}">
                                    <span class="search-result__name">${product.title}</span>
                                </a>
                                <div class="nosto-bottom-bar">
                                <div class="price-container-nosto-api">

                                <span class="search-result__price money grid-product__price price" style="">${currencyCode}${selectedVariantPrice}</span>
                                <span class="search-result__price money grid-product__price price-compare-nosto" style="display:none;">119.99 $</span>

                                <span class="sale-perc"></span>
                        
                                </div>
                                
                                </div>                            
                            </div>
                            </div>
                            
                            <div class="swymcs-atc-container">
                                ${variantSelector}
                            </div>

                            <div class="swymcs-atc-container ">
                                <button ${isButtonDisabled} data-purpose="cart" data-du="${pdp.reqURL}" data-epi="${selectedVariant.id}" data-empi="${product.id}" class="btn btn--primary ${inCart} quick-add__submit button button--full-width button--primary swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}" data-variant-cost="${selectedVariantPrice}">
                                    ${addToCartBtnText}
                                </button>
                            </div>

                            ${backInStockButton}

                        </div>

                    `
                });
            }
            const container = gridtype === 'WL' ? this.productsContainer : gridtype === 'SFL' ? this.SFLProductsContainer : null;
            if (container) {
                container.innerHTML = productMarkup;
                container.classList.remove('swymcs-empty-list');
            }
            this._scrollToTop();
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }

        _renderEmptyList() {
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
            this._hideContainer(this.wishlistFooter);
        }

        async _renderShareListPopup(evt) {
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup(evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if (target.id == 'swymcs-additional-options') return;
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action;
            page._closeAdditionalOptionsPopup();
            if (action == 'share') page._renderShareList();
            else if (action == 'delete') page._renderDeleteList();
        }

        _renderDeleteListPopup()
        {
            this._closeAdditionalOptionsPopup();
            this._renderDeleteList();
        }

        _closeAdditionalOptionsPopup() {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isCustomer) {
                this._showPopupContainer(this.shareListAccountPopup);
                return;
            }
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList() {
            //this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt) {
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        _scrollToTop() {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer(selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer(selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer(selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer(selector) {
            selector.classList.add('swym-hide-container');
        }

        /* Javascript APIs related functions */
        _getLists() {
            return new Promise(async(resolve, reject) => {
                this.swat.fetchLists({
                    callbackFn: lists => resolve(lists),
                    errorFn: err => reject(err)
                });
            });
        }

        _getListDetails(lid) {
            return new Promise(async(resolve, reject) => {
                this.swat.fetchListDetails({ lid: lid },
                    list => resolve(list),
                    error => reject(error)
                );
            });
        }

        _getProductsFromList(lid) {
            return new Promise(async(resolve, reject) => {
                this.swat.fetchListCtx({ lid: lid },
                    listContents => resolve(listContents),
                    error => reject(error)
                );
            });
        }

        async _getShopifyProductsData(products) {
            if (!products.length) return [];
            const section = this;
            let buggedProductsArray = [];
            let res = await Promise.all(products.map(async(pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `https://${window.shopDomain}/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    pdp.reqURL = reqURL;
                    return pdp;
                } catch (error) {
                    const errorObj = {};
                    errorObj[pdp.du] = error;
                    buggedProductsArray.push(errorObj);
                    return null;
                }
            }));
            //console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _subscribeToAlert(epi,empi,du,iu,pr){
            let event = null
            let renderIntoNodeopt = null;
            let product = {
                epi: epi,
                empi: empi,
                du: du,
                iu: iu,
                pr: pr,
                et: 8
            }
            let onSuccess = function(response) {
                //console.log("Popup successfully opened.", response);
            }
            let topic = "comingsoon";
            this.swat.addToWatchList(event, product, onSuccess, renderIntoNodeopt, topic);
        }

        _deleteProductFromList(product, lid, parentNode) {
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if (!this.productsContainer.querySelector('.swymcs-product-card')) {
                    this._renderProductsGrid([],'WL');
                }
                this.lists = await this._getLists();
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _deleteList() {
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderProductsGrid([],'WL');
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value == '' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if (isBlank || isInvalidString) {
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button) {
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;

            _swat.replayAddToCart(
                { empi: empi, du: du, qty: 1},epi,
                (success) => {
                    button.classList.add('swymcs-product-in-cart');
                    button.textContent = _swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded;
                    const productCard = button.closest("div.swymcs-product");
                    const select = productCard.querySelector('select[data-purpose="select"]');
                    const selectedOption = select.options[select.selectedIndex];
                    selectedOption.dataset.incart = "true";
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
                },
                (error) => {
                    button.textContent = 'Lägg till i varukorg';
                    _swat.ui.uiRef.showErrorNotification({ message: error.description });
                    console.error('Error:', error);
                }
            );
        }

        _markListAsPublic() {
            return new Promise(async(resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list) {
            return new Promise(async(resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy() {
            navigator.clipboard.writeText(this.shareLinkField.textContent)
                .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
                .catch(error => _swat.ui.uiRef.showErrorNotification({ message: error.description }));
        }

        _shareListByEmail() {
            const email = this._validateEmail();
            if (!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({ message: 'List shared successfully over mail' });
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({ message: error.description });
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform) {
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({ message: error.description });
            let platformShareUrlTemplate = '';
            if (platform == 'facebook')
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if (platform == 'twitter')
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`;
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt) {
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        _selectProductSize(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset ?.purpose;

            if (!purpose) return;
            evt.preventDefault();

            if (purpose == 'select')
            {    
                const productCard = target.closest("div.swymcs-product");
                const addToCartButton = productCard.querySelector('button[data-purpose="cart"]');
                const backInStockButton = productCard.querySelector('button[data-purpose="subscribe"]');
                const selectedOption = target.options[target.selectedIndex];
                addToCartButton.dataset.epi = selectedOption.value;
                addToCartButton.disabled = selectedOption.dataset.available === "false";
                addToCartButton.innerText = selectedOption.dataset.available === "true" ? (selectedOption.dataset.incart === "true" ? `${_swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded}` : `${_swat.retailerSettings.Strings.AddToCartCTACanAdd}`) : `${_swat.retailerSettings.Strings.AddToCartCTAUnavailable}`;
                if (backInStockButton)
                    selectedOption.dataset.available === "true"
                    ? (
                        page._hideContainer(backInStockButton),
                        target.classList.remove('swym-strikethrough')
                    )
                    : (
                        backInStockButton.dataset.epi = selectedOption.value,
                        page._showContainer(backInStockButton),
                        target.classList.add('swym-strikethrough')
                    );
            }
        }

        /* Product Grid Events */

        async _eventsForProductsGrid(evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset ?.purpose;
            if (!purpose) return;
            evt.preventDefault();
            if (purpose == 'cart') page._addProductToCart(target);
            else if (purpose == 'delete') {
                page._deleteProductFromList({
                    "epi": target.dataset.epi,
                    "empi": target.dataset.empi,
                    "du": target.dataset.du
                }, target.dataset.lid, target.closest('.product'));
            }
            else if (purpose == 'subscribe'){
                page._subscribeToAlert(target.dataset.epi,target.dataset.empi,target.dataset.du,target.dataset.iu,target.dataset.pr);
            }
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}